import { MaintenancePageId } from 'app/modules/settings/domain/valueObject/MaintenancePageId';
import { MaintenancePageName } from 'app/modules/settings/domain/valueObject/MaintenancePageName';
import { MaintenancePageOrigin } from 'app/modules/settings/domain/valueObject/MaintenancePageOrigin';
import { TranslationArray } from 'app/modules/settings/domain/entity/TranslationArray';

export class MaintenancePage {

    private readonly _id: MaintenancePageId;
    private readonly _origin: MaintenancePageOrigin;
    private readonly _name: MaintenancePageName;
    private readonly _translations: TranslationArray;
    private _inMaintenance: boolean;

    public constructor(
        id:MaintenancePageId,
        origin:MaintenancePageOrigin,
        name:MaintenancePageName,
        translations:TranslationArray,
        inMaintenance:boolean,

    ) {
        this._id = id;
        this._origin = origin;
        this._name = name;
        this._translations = translations;
        this._inMaintenance = inMaintenance;

    }

    public get id(): MaintenancePageId {
        return this._id;
    }

    public get origin(): MaintenancePageOrigin {
        return this._origin;
    }

    public get name(): MaintenancePageName {
        return this._name;
    }

    public get translations(): TranslationArray {
        return this._translations;
    }

    public get inMaintenance(): boolean {
        return this._inMaintenance;
    }

    public set inMaintenance(value: boolean) {
        this._inMaintenance = value;
    }

}
